import './Theme/plugins/fancybox/jquery.fancybox.css';
import './Theme/css/css.css';
import './Theme/css/font-awesome-4.7.0/css/font-awesome.min.css';
import './Theme/css/animate.css';
import React, { useEffect, useState } from 'react';
import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css'; 
import Header from './Header';
import Menu from './CommonMenu';
import $ from 'jquery';
import { API_URL, FILE_URL, LINK_YOUTUBE_IMAGE } from './Constants';
import HomePageApi from './HomePageApi';
window.jQuery = $;
require('textillate');
require('letteringjs');
require('slick-carousel');


function HomePage() {
  const [slideHome, setSlideHome] = useState([]);
  const [videoMoiCapnhat, setVideoMoiCapnhat] = useState([]);
  const [audioMoiCapnhat, setAudioMoiCapnhat] = useState([]);
  const [sachNoiMoiCapnhat, setSachNoiMoiCapnhat] = useState([]);
  const [kinhVaAudioMoiCapnhat, setKinhVaAudioMoiCapNhat] = useState([]);
  const [guongSangTuHanh, setGuongSangTuHanh] = useState([]);
  const [giangSu, setGiangSu] = useState([]);
  const [tintuc, setTinTuc] = useState([]);
  const [thuVienKinhSach, setThuVienKinhSach] = useState([]);
  const [nhacPhatGiao, setNhacPhatGiao] = useState([]);
  const [thongKe, setThongKe] = useState([]);
  const [slideHeader, setSlideHeader] = useState([]);

  useEffect(() => {
    $('.tlt').textillate({
      loop: true,
      minDisplayTime: 20000,
      in: {
        effect: 'fadeIn',
        delayScale: 3,
        shuffle: false,
      },
      out: {
        effect: 'fadeOut',
        delayScale: 1.5,
        delay: 100,
        sync: false,
        shuffle: false,
        reverse: false,
      }
    });

    $("#sky-bg").fadeIn(2e3);

    HomePageApi.getDataSlideShow().then((data) => {
      setSlideHome(data); // Update state with the resolved data
    })

    HomePageApi.getDataHeaderSlideShow().then((data) => {
      setSlideHeader(data);
    })

    HomePageApi.getDataVideoMoiCapNhat().then((data) => {
      data.forEach((item) => {
        const videoId = getVideoID(item.value)
        item.imageUrl = LINK_YOUTUBE_IMAGE.replace('{videoId}', videoId);
      });
      setVideoMoiCapnhat(data); // Update state with the resolved data
    })

    HomePageApi.getDataAudioMoiCapNhat().then((data) => {
      setAudioMoiCapnhat(data); // Update state with the resolved data
    })

    HomePageApi.getDataSachNoiMoiCapNhat().then((data) => {
      setSachNoiMoiCapnhat(data); // Update state with the resolved data
    })

    HomePageApi.getDataKinhVaAudioMoiCapNhat().then((data) => {
      setKinhVaAudioMoiCapNhat(data); // Update state with the resolved data
    })

    HomePageApi.getDataGuongSangTuHanh().then((data) => {
      setGuongSangTuHanh(data); // Update state with the resolved data
    })

    HomePageApi.getDataGiangSu().then((data) => {
      setGiangSu(data); // Update state with the resolved data
    })

    HomePageApi.getDataTinTuc().then((data) => {
      setTinTuc(data); // Update state with the resolved data
    })

    HomePageApi.getDatathuVienKinhSach().then((data) => {
      setThuVienKinhSach(data); // Update state with the resolved data
    })

    HomePageApi.getDataNhacPhatGiao().then((data) => {
      setNhacPhatGiao(data); // Update state with the resolved data
    })

    HomePageApi.getDataThongKe().then((data) => {
      setThongKe(data); // Update state with the resolved data
    })
  }, []);

  useEffect(() => {
    if (slideHome.length > 0 && !$(".slideHomeFade").hasClass('slick-initialized')) {
      $(".slideHomeFade").slick({
        arrows: false,
        lazyLoad: "ondemand",
        dots: false,
        infinite: true,
        speed: 2000,
        fade: true,
        slide: "div",
        autoplay: true,
        autoplaySpeed: 2000,
        cssEase: "linear"
      });
    }

    if (slideHeader.length > 0 && !$(".slideHeaderFade").hasClass('slick-initialized')) {
      $(".slideHeaderFade").slick({
        arrows: false,
        dots: false,
        infinite: true,
        speed: 1000,
        fade: true,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: "linear",
        pauseOnHover: false
      });
    }

    if (thuVienKinhSach.length > 0 && !$(".slideKinhSachUpdate").hasClass('slick-initialized')) {
      $(".slideKinhSachUpdate").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        speed: 3000,
        dots: false,
        autoplaySpeed: 5000,
      });
    }

    // Cleanup Slick instances
    return () => {
      if (slideHome.length > 0 && $(".slideHomeFade").hasClass('slick-initialized')) {
        $('.slideHomeFade').slick('unslick');
      }
      if (slideHeader.length > 0 && $(".slideHeaderFade").hasClass('slick-initialized')) {
        $('.slideHeaderFade').slick('unslick');
      }
      if (thuVienKinhSach.length > 0 && $(".slideKinhSachUpdate").hasClass('slick-initialized')) {
        $('.slideKinhSachUpdate').slick('unslick');
      }
    };
  }, [slideHome, thuVienKinhSach]);

  const getVideoID = (url) => {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^&\n]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta httpEquiv="Content-Language" content="vi" />
      <title>Pháp Ấn Sơn | Linh Quy Pháp Ấn</title>
      <link rel="shortcut icon" href="/Upload/images/tab/logochuan.jpg" type="image/png" />
      <meta name="keywords" content="linh quy pháp ấn; linh quy phap an; Nikaya;  linhquyphapan; linhquy" />
      <meta name="description" content=" Pháp Ấn Sơn" />

      {/* <link href='https://fonts.googleapis.com/css?family=Roboto+Condensed|Open+Sans:400,700,400italic' rel='stylesheet' type='text/css'>
          <link href="/Theme/plugins/fancybox/jquery.fancybox.css" rel="stylesheet" />
          <link href="/Theme/css/css.css" rel="stylesheet"/>
          <link rel="stylesheet" href="/Theme/css/font-awesome-4.7.0/css/font-awesome.min.css">
          <link href="/Theme/css/animate.css" rel="stylesheet" />
          
          <script src="/Theme/js/jquery-1.11.2.min.js"></script> */}
      <div className="fly-text">
        <ul>
          <li className="tlt">Nguyện thành tựu</li>
          <li className="tlt">Lòng tin bất động</li>
          <li className="tlt">Nơi Đức Phật, Chánh Pháp</li>
          <li className="tlt">Chúng Tăng và Thánh Giới</li>
          <li className="tlt" />
        </ul>
      </div>
      <div id="sky-bg">
        <div className="clouds_one" />
        <div className="clouds_two" />
        <div className="clouds_three" />
      </div>
      <Header />
      <section>
        <div className="container contentContainer">
          <div className="row">
            <div className="col-md-12">
                <div className="slideHeaderFade" style={{marginBottom: '20px'}}>
                    {slideHeader.map((item, index) => (
                        <div className="itemSlideHeader" key={index}>
                            <a href={item.Value}>
                                <img src={FILE_URL + item.Thumb} alt="Slide Header" style={{width: '100%', borderRadius: '8px'}} />
                            </a>
                        </div>
                    ))}
                </div>
            </div>
          </div>
          <style type="text/css" dangerouslySetInnerHTML={{ __html: "\n.all_link{\n\tfloat: right;\n    COLOR: #80271A;\n    MARGIN-TOP: 5PX;\n    FONT-FAMILY: 'Roboto Condensed', Arial;\n}\n" }} />
          <div className="row">
            <div className="col-md-9 col-sm-9 col-xs-12">
              <Menu value={"home"} />
              <div className="homeVideo">
                <div className="slideHomeFade">
                  {slideHome.map((item, index) => (
                    <div className="itemlideHomeFade" key={index}>
                      <a href={item.Value}>
                        <img src={FILE_URL + item.Thumb} alt="Image description" />
                      </a>
                    </div>
                  ))}
                </div>

                <div className="slogan" style={{ height: '50px' }}>
                </div>
                <div className="homeListVideoUpdate wow fadeInUp" data-wow-delay="1s">
                  <h5 className="tittleHome">VIDEO VỪA ĐƯỢC CẬP NHẬT <a href="video" className="tittleHome" style={{ float: 'right', color: '#660000' }}>XEM TẤT CẢ VIDEO</a></h5>
                  <div className="row">
                    {videoMoiCapnhat.map((item, index) => (
                      <div className="col-md-3 col-sm-6 col-xs-6 itemHomeListVideo itemListVideoTab" key={index}>
                        <div className="containerOverlay">
                          <img className="thumbHover lazy" alt="" title={item.title} src={item.imageUrl} />
                          <div className="overlay">
                            <a className="videoHover1" href={`/video/${item.Slug_Full}?id=${item.id}`} alt="Xem"> <i className="fa fa-eye " /> Xem</a>
                            <a className=" videoHover2  iconDonwload2 btnAddFav" data-id={item.id} data-type="video" data-title={item.title}><i className="fa fa-plus-square" /> Thêm</a>
                            <a className="iconDonwload2 videoHover3 fancybox fancybox.ajax" href="javascript:;" data-fancybox-href="/Widget/YoutubeDownload/30119?videourl=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DceuQQjakPOw">
                              <i className="fa fa-download" /> Tải
                            </a>
                          </div>
                        </div>
                        <div className="listVideoTitle2">
                          <a className="Title" href={`/video/${item.Slug_Full}`}>
                            {item.title}
                          </a>
                          <p>
                          </p>
                        </div>
                      </div>
                    ))}

                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-xs-12 homeListAudio wow fadeInLeft" data-wow-delay="0.2s">
                  <h5 className="tittleHome">AUDIO MỚI CẬP NHẬT</h5>
                  <table className="tableHomeListAudio">
                    <thead>
                      <tr>
                        <th> </th>
                        <th> Tiêu đề </th>
                        <th><i className="fa fa-headphones fa-fw" /> Nghe </th>
                      </tr>
                    </thead>
                    <tbody>
                      {audioMoiCapnhat.map((item, index) => (
                        <tr>
                          <td>
                            <span className="count">{index + 1}</span>
                          </td>
                          <td className="list-title">
                            <a href={`/audio/${item.Slug_Full}?id=${item.id}`}>
                              <i className="fa fa-volume-up" />
                              {item.title}
                            </a>
                            <span>
                              {item.value}
                            </span>
                          </td>
                          <td> {item.ViewedCount}</td>
                        </tr>

                      ))}
                    </tbody>
                  </table>
                  <div><a href="audio" className="all_link">NGHE TẤT CẢ AUDIO</a></div>
                </div>
                <div className="col-sm-6 col-xs-12 homeListAudio wow fadeInRight" data-wow-delay="0.2s">
                  <h5 className="tittleHome">SÁCH NÓI MỚI CẬP NHẬT</h5>
                  <table className="tableHomeListAudio">
                    <thead>
                      <tr>
                        <th> </th>
                        <th> Tiêu đề </th>
                        <th><i className="fa fa-headphones fa-fw" /> Nghe </th>
                      </tr>
                    </thead>
                    <tbody>
                      {sachNoiMoiCapnhat.map((item, index) => (
                        <tr>
                          <td>
                            <span className="count">{index + 1}</span>
                          </td>
                          <td className="list-title">
                            <a href={`/sach-noi/${item.Slug_Full}`}>
                              <i className="fa fa-volume-up" />
                              {item.newpost && <img src={require("./Theme/img/icon/new.gif")} />}
                              {item.title}
                            </a>
                            <span>
                            </span>
                          </td>
                          <td>{item.ViewedCount}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div><a href="sach-noi" className="all_link">NGHE TẤT CẢ SÁCH</a></div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="homeListAudio">
                    <h5 className="tittleHome">Kinh NIKAYA phân loại</h5>
                    <div className="text-center">
                      <div className="row">
                        <div className="col-md-6">
                          <a href="https://play.google.com/store/apps/details?id=vn.linhquyphapan.kinhnikaya"><img src={require("./Upload/images/Album-Hinh-Anh/Nikaya/android.jpg")} /></a>
                        </div>
                        <div className="col-md-6">
                          <a href="https://apps.apple.com/vn/app/kinh-nikaya-ph%C3%A2n-lo%E1%BA%A1i/id1439733311"><img src={require("./Upload/images/Album-Hinh-Anh/Nikaya/ioschuan3.jpg")} /></a>
                        </div>
                        <div className="text-center">
                          <a href={`/audio-theo-bo/${kinhVaAudioMoiCapnhat[0] && kinhVaAudioMoiCapnhat[0].Slug_Full}`}>
                            <img src={FILE_URL + `${kinhVaAudioMoiCapnhat[0] ? kinhVaAudioMoiCapnhat[0].Thumb : ""}`} alt="Kinh NIKAYA Giảng Giải" style={{ height: '289px' }} />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="homeListAudio">
                    <h5 className="tittleHome">Audio Theo bộ</h5>
                    <div className="text-center">
                      <a href={`/audio-theo-bo/${kinhVaAudioMoiCapnhat[1] && kinhVaAudioMoiCapnhat[1].Slug_Full}`}>
                        <img src={FILE_URL + `${kinhVaAudioMoiCapnhat[1] ? kinhVaAudioMoiCapnhat[1].Thumb : ""}`} alt="Kinh NIKAYA Giảng Giải" style={{ height: '289px' }} />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="homeListAudio guong-sang-tu-hanh wow fadeInLeft" data-wow-delay="0.2s">
                    <h5 className="tittleHome">Gương sáng tu hành</h5>
                    {guongSangTuHanh.map((item, index) => (
                      <div className="col-md-6 col-sm-6 col-xs-6  itemAudioSachNoiList homeGiangSu">
                        <div className="row">
                          <div className="col-md-6 col-sm-6 col-xs-6 imageListAudioSachNoiList ">
                            <a href={`/${item.Slug_Full}`}>
                              {/* <img alt={item.Title} title={item.Title} src={FILE_URL + `${item.Thumb}`} /> */}
                              <img src={FILE_URL + `${item.Thumb ? item.Thumb : ""}`} alt={item.Title} />
                            </a>
                          </div>
                          <a href={`/${item.Slug_Full}`} className="col-md-6 col-sm-6 col-xs-6">
                            <h4>{item.Title}</h4>
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="homeListAudio giang-su wow fadeInRight" data-wow-delay="0.2s">
                    <h5 className="tittleHome">Giảng sư</h5>

                    {giangSu.map((item, index) => (
                      <div className="col-md-6 col-sm-6 col-xs-6  itemAudioSachNoiList homeGiangSu">
                        <div className="row">
                          <div className="col-md-6 col-sm-6 col-xs-6 imageListAudioSachNoiList ">
                            <a href={`/${item.Slug_Full}`}>
                              <img src={FILE_URL + `${item.Thumb ? item.Thumb : ""}`} alt={item.Title} />
                            </a>
                          </div>
                          <a href={`/${item.Slug_Full}`} className="col-md-6 col-sm-6 col-xs-6">
                            <h4>{item.Title}</h4>
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
              <div className="boxNews wow fadeInRight" data-wow-delay="0.2s">
                <div className="containerRightBox">
                  <h5 className="titleRightHome">TIN TỨC</h5>

                  {tintuc.map((item, index) => (
                    <div className="noiDungHomeTinTuc clearfix">
                      <img src={FILE_URL + `${item.Thumb ? item.Thumb : ""}`} alt={item.Title} />
                      <h5>
                      <a href={`/tin-tuc-chi-tiet/${item?.Slug_Full}?id=${item?.id}`}>{item.Title}</a>
                      </h5>
                      <em>{item.Date_Create}</em>
                      <p>
                        {item.Description.length > 10
                          ? `${item.Description.substring(0, 105)}...`
                          : item.Description}
                      </p>
                      <a className="seemore" href={`/tin-tuc/${item.Slug_Full}`}>Xem chi tiết <i className="fa fa-angle-double-right" /></a>
                    </div>
                  ))}

                </div>
              </div>
              <div className="boxNews wow fadeInRight" data-wow-delay="0.4s">
                <div className="containerRightBox">
                  <h5 className="titleRightHome">Lời Phật dạy</h5>
                  {tintuc.map((item, index) => (
                    index < 2 &&
                    (<div className="noiDungHomeTinTuc clearfix">
                      <img src={FILE_URL + `${item.Thumb ? item.Thumb : ""}`} alt={item.Title} />
                      <h5><a href={`/tin-tuc/${item.Slug_Full}`}>{item.Title}</a></h5>
                      <em>{item.Date_Create}</em>
                      <p>
                        {item.Description.length > 10
                          ? `${item.Description.substring(0, 105)}...`
                          : item.Description}
                      </p>
                      <a className="seemore" href={`/tin-tuc/${item.Slug_Full}`}>Xem chi tiết <i className="fa fa-angle-double-right" /></a>
                    </div>
                    )
                  ))}
                </div>
              </div>
              <a href="https://play.google.com/store/apps/details?id=vn.linhquyphapan.lqpa" target="_blank"><img src={require("./Theme/img/linhquy-android.jpg")} /></a>
              <a href="https://itunes.apple.com/vn/app/linh-quy-ph%C3%A1p-%E1%BA%A5n/id1336999832?l=vi&mt=8" target="_blank"><img src={require("./Theme/images/download-appstore.jpg")} /></a>
              <div className="homeKinhSach clearfix wow fadeInRight" data-wow-delay="0.4s">
                <h5 className="tittleHome">THƯ VIỆN KINH SÁCH</h5>
                <div className="slideKinhSachUpdate">

                  {thuVienKinhSach.map((item, index) => (
                    <div className="itemslideHomeKinhSach">
                      <a href={`/kinh-sach/${item.Slug_Full}`}>
                        <img src={FILE_URL + `${item.Thumb ? item.Thumb : ""}`} alt={item.Title} />
                      </a>
                    </div>
                  ))}

                </div>
              </div>
              <div className="homeListAudio wow fadeInRight" data-wow-delay="0.4s" >
                <h5 className="tittleHome">NHẠC PHẬT GIÁO MỚI CẬP NHẬT</h5>
                <table className="tableHomeListAudio">
                  <thead>
                    <tr>
                      <th> </th>
                      <th> Tiêu đề </th>
                      <th><i className="fa fa-headphones fa-fw" /> Nghe </th>
                    </tr>
                  </thead>
                  <tbody>

                    {nhacPhatGiao.map((item, index) => (
                      <tr>
                        <td>
                          <div className="containerOverlay" style={{ height: 'auto', marginRight: '10px' }}>
                            <img src={FILE_URL + `${item.Thumb ? item.Thumb : ""}`} alt={item.Title} style={{ width: '70px' }} />
                            <div className="overlay">
                              <a className="iconDonwload2 videoHover3" href={`/nhac-phat-giao/${item.Slug_Full}`} style={{ right: '40%' }}>
                                <i className="fa fa-play" />
                              </a>
                            </div>
                          </div>
                        </td>
                        <td className="list-title">
                          <a href={`/nhac-phat-giao/${item.Slug_Full}`}>
                            <i className="fa fa-volume-up" />
                            {item.Title}
                          </a>
                          <span>{item.Description}</span>
                        </td>
                        <td>{item.ViewedCount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="boxNews soisang wow fadeInRight" data-wow-delay="0.4s">
                <div className="containerRightBox">
                  <h5 className="titleRightHome">Soi sáng</h5>
                  <table className="tableHomeListAudio soiSangHome">
                    <tbody>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row" data-wow-delay="0.4s">
                <div className="col-md-12 col-sm-12 col-xs-12   none-padding-left">
                  <a className="playlistWidget" href="/danh-sach-playlist/1">
                    <img src={require("./Theme/img/show_playlist.png")} />
                  </a>
                </div>
              </div>
              <div className="homestats">
                <h5 className="tittleHome">THỐNG KÊ</h5>
                <ul>
                  <li className="text-center">
                    <strong>Chi tiết thống kê</strong>
                  </li>
                  <li>
                    <i className="fa fa-globe" />
                    Đang truy cập: 1
                  </li>
                  <li>
                    <i className="fa fa-globe" />
                    Lượt truy cập : {thongKe[0] && thongKe[0].TotalCounter}
                  </li>
                  <li>
                    <i className="fa fa-headphones" />
                    Tổng lượng nghe : {thongKe[0] && thongKe[0].TotalViews}
                  </li>
                  <li>
                    <i className="fa fa-download" />
                    Tổng Download : {thongKe[0] && thongKe[0].TotalDownload}
                  </li>
                  <li className="text-center">
                    <strong>Thống kê hôm nay</strong>
                  </li>
                  <li>
                    <i className="fa fa-users" />
                    Lượt truy cập hôm nay: {thongKe[0] && thongKe[0].countUserVisitToday}
                  </li>
                  <li>
                    <i className="fa fa-cloud-download" />
                    Download trong ngày : {thongKe[0] && thongKe[0].countDownloadToday}
                  </li>
                  <li>
                    <i className="fa fa-user" />
                    <a href="/Dang-nhap">Đăng nhập</a>
                  </li>
                </ul>
              </div>
              <div className="homestats">
                <h5 className="tittleHome">LIÊN KẾT</h5>
                <ul>
                  <li>
                    <i className="fa fa-facebook" />
                    <a href="https://www.facebook.com/LINH-QUY-PH%C3%81P-%E1%BA%A4N-260666811038785/" target="_blank">Facebook</a>
                  </li>
                  <li>
                    <i className="fa fa-youtube" />
                    <a href="https://www.youtube.com/channel/UCnI54Nrr9AddC4pDdpIjyCg" target="_blank">YouTube</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/*// content */}
      </section>
      <footer>
        <div className="container">
          {/* <div className="_Slide3DContainer wow fadeInUp" data-wow-delay="0.4s">
            <ul className="carousel ">
              <li className="item active">
                <a href="/kinh-sach/cua-vao-bat-tu" className="itemSlide3d" tipcontent="CỬA VÀO BẤT TỬ"><img src={require("./Upload/images/z2345923129108_b9a2cd08e07aba3cab7e274c4c1896db.jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/nghi-thuc-tu-hoc-nikaya" className="itemSlide3d"><img src={require("./Upload/images/Nghi Thức Tu Học NIKAYA(1).jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/phap-hanh-nikaya-can-ban" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hy-ngot-ngao" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hien-van-an" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
            </ul>
          </div> */}
        </div>
      </footer>
      <section className="footer-copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-1">
              <img className="img-responsive" src={require("./Theme/img/linhqquylogo-small.jpg")} />
            </div>
            <div className="col-md-5">
              Copyright © 2011 - 2024<br />Linhquyphapan.vn, All right reserved <br />Chủ nhiệm: Thượng Toạ Thích Minh Thành
            </div>
            <div className="col-md-6">
              Thôn 4 - Xã Lộc Thành - Huyện Bảo Lâm - Tỉnh Lâm Đồng <br />SĐT: 0963 232 651 , 0766 522 181<br />Email: linhquyphapan@yahoo.com <br /> www.linhquyphapan.vn
            </div>
          </div>
        </div>
      </section>
      <p id="back-top" style={{ display: 'none' }}>
        <a href="#top"><span /></a>
      </p>
      <div id="fb-root" />
    </div>
  );
}

export default HomePage;
